/*
 * @Author: zhengxiaowen
 * @Date: 2018-08-21 11:49:51
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-22 10:26:11
 */
import fetchTool from '@/common/tool/fetchTool'
import apiPage from './apiPage'

// ******** 框架 start ********
import demoFatch from './demo/config/fetchData'
// ******** 框架 end ********

// *** 业务模块 start ***

// *** 业务模块 end ***

let fetchDataPage = {}

// 登录
fetchDataPage.login = (params) => fetchTool.post(apiPage.login, params)

// 数据字典
fetchDataPage.findDic = (params) => fetchTool.post(apiPage.findDic, params)

//
fetchDataPage.base64ImgUpload = (params) => fetchTool.post(apiPage.base64ImgUpload, params)

// 获取导购员信息
fetchDataPage.oaHrGuideRService_findGuideInfo = (params) => fetchTool.post(apiPage.oaHrGuideRService_findGuideInfo, params)

// ***** 流程 start *****

// 发起流程
fetchDataPage.bpmProcessService_start = (params) => fetchTool.post(apiPage.bpmProcessService_start, params)

// 流程撤回
fetchDataPage.bpmTaskService_revoke = (params) => fetchTool.post(apiPage.bpmTaskService_revoke, params)

// 审批信息
fetchDataPage.bpmHistoryService_findHistoricActivities = (params) => fetchTool.post(apiPage.bpmHistoryService_findHistoricActivities, params)

// ***** 流程 end *****

fetchDataPage = Object.assign(fetchDataPage,demoFatch)

// *** 业务模块 start ***

// *** 业务模块 end ***


export default fetchDataPage



// WEBPACK FOOTER //
// ./src/page/fetchDataPage.js